//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import * as d3 from 'd3';
import d3tip from 'd3-tip'
import { schemeCategory10 } from 'd3-scale-chromatic';
import * as Helpers from '../../Common/Helpers';
import { exportEmployeeReportImage, deleteEmployeeReportImage } from './NewEmployeeReportButtonHelpers'
import { Heading3, ReportButton, ReportText, TextLink, TextSpan } from '../../Common/SharedStyledComponents';
import { downloadNewEmployeeReportData } from "./../../../actions/NewEmployeeReportActions";
import { TitleDiv } from "./Earnings";

const TopCompanies = ({ parentWidth, EmployeeCompany, statecode, employeeTypes, industries, agg, university, state, props }) => {
    //check if reports is loading form shared link
    let isSharedReport = false;
    let params = useParams();

    if (params) {
        isSharedReport = params["link_id"] !== undefined && params["p1"] !== undefined && params["p2"] !== undefined;
    }
    
    const employeeProfileReportState = useSelector(state => state.newEmployeeReportProperties);

    //list of companies that don't pass the privacy threshold, this is being set in the useEffect function
    const [filteredArray, setFilteredArray] = useState([]);
    const [selectedType, setSelectedType] = useState("Graduate Student");
    const [selectedIndustry, setSelectedIndustry] = useState("");

    const dispatch = useDispatch();

    useEffect(() => {
        if (employeeTypes.length > 0 && industries.length > 0) {
            if (selectedIndustry == "") {
                selectedIndustry = industries[0].type;
                setSelectedIndustry(industries[0].type);
            }

            let filteredByTypeAndIndustry = EmployeeCompany.filter(x => +x.statecode == statecode
                && x.employee == selectedType
                && (x.industry) == selectedIndustry);

            filteredByTypeAndIndustry = filteredByTypeAndIndustry.sort((a, b) => (a.median_salary < b.median_salary) ? 1 : -1);

            const nonePrivacyList = filteredByTypeAndIndustry.filter(x => x.count > 0);
            nonePrivacyList = nonePrivacyList.slice(0, 10);
            //companies = filteredByTypeAndIndustry.map(x => (x.company_name));

            setFilteredArray((_) => {
                const privacyList = filteredByTypeAndIndustry.filter(x => x.count == 0);
                privacyList = privacyList.sort((a, b) => (a.company_name < b.company_name) ? -1 : 1);

                return privacyList;
            });

            d3.select("#BarChart svg").remove();
            deleteEmployeeReportImage("chart3.png", state, props)
            if (nonePrivacyList.length > 0) {

                var margin = { top: 25, right: 75, bottom: 60, left: 300 },
                    width = (parentWidth+50 || 875) - margin.left - margin.right,
                    height = 320 - margin.top - margin.bottom;

                // append the svg object to the body of the page
                var svg = d3.select("#BarChart")
                    .append("svg")
                    .attr("width", width + margin.left + margin.right)
                    .attr("height", height + margin.top + margin.bottom)
                    .append("g")
                    .attr("transform",
                        "translate(" + margin.left + "," + margin.top + ")");

                const data = nonePrivacyList;

                // Add X axis
                var x = d3.scaleLinear()
                    .domain([0, d3.max(data, function (d) {
                        return d.median_salary;
                    })])
                    .range([0, width]);

                svg.append("g")
                    .attr("transform", "translate(0," + height + ")")
                    .classed('tick_style_companies', true)
                    .call(d3.axisBottom(x).tickSizeOuter(0).tickFormat(x => `${(Helpers.billionNumberFormat(x))}`))
                    .selectAll("text")
                    .style("text-anchor", "middle");

                // Y axis
                var y = d3.scaleBand()
                    .range([0, height])
                    .domain(data.map(
                        function (d) {
                            return Helpers.toTitleCase(d.company_name) + ' (' + d.count + ')';
                        }))
                    .padding(.1);

                svg.append("g")
                    .classed('tick_style_companies', true)
                    .call(d3.axisLeft(y)
                        .tickSizeOuter(0)
                        .tickSize(0)
                        .tickPadding(10)
                        .tickFormat(d => Helpers.truncate(d,40))
                    )

             
                // color palette = one color per subgroup
                var color = d3.scaleOrdinal()
                    .domain(nonePrivacyList.map(c => c.company_name))
                    .range(schemeCategory10)

                // Define the div for the tooltip
                var tooltipCompanies = d3.select("#EmployeeChart").append("div")
                    .attr("class", "er_tooltip")
                    .style("opacity", 0);

                //Bars
                svg.selectAll("myRect")
                    .data(data)
                    .enter()
                    .append("rect")
                    .attr("x", x(0)+1)
                    .attr("y", d => y(Helpers.toTitleCase(d.company_name) + ' (' + d.count + ')'))
                    .attr("width", d => x(d.median_salary))
                    .attr("height", y.bandwidth()-10)
                    //.attr("fill", d => color(d.company_name))
                    .attr("fill", "#ADD8E6")
                    .on('mouseover', d => {
                        const dataValue = d.target.__data__;

                        const tooltipHtml = `${Helpers.toTitleCase(dataValue.company_name)}: $${dataValue.median_salary.toLocaleString()}`

                        tooltipCompanies.style("opacity", .9);
                        tooltipCompanies.html(tooltipHtml)
                            .style("left", (d.layerX) + "px")
                            .style("top", (d.screenY) + "px");
                    })
                    .on("mouseout", function (d) {
                        tooltipCompanies.transition()
                            //.duration(500)
                            .style("opacity", 0);
                    })


                svg.append("text")
                    .attr("text-anchor", "end")
                    .attr("x", width/2)
                    .attr("y", height + margin.top + 30)
                    .classed('axis_style', true)
                    .text("Median Earnings ($)");

                // Y axis label:
                svg.append("text")
                    .attr("text-anchor", "end")
                    .attr("transform", "rotate(-90)")
                    .attr("y", -margin.left + 20)
                    .attr("x", -margin.top - 80)
                    .classed('axis_style', true)
                    .text("Company (Count)")

                exportEmployeeReportImage("#earnings-in-top-10-companies", "chart3.png", props.NewEmployeeReportState, props.UserState.report_display_id, state.currentDateTime, "no", props.UserState.report_vintage_sb_employee);

            }

        }

    }, [statecode, employeeTypes, industries, selectedType, selectedIndustry, parentWidth])

    const handleType = (selectedType) => {
        setSelectedType(selectedType)
    }

    const handleIndustry = (selectedIndustry) => {
        setSelectedIndustry(selectedIndustry)
    }
    
    return (
        <Container>
            <div id="earnings-in-top-10-companies">
                <TitleDiv>
                    <Heading3 bold center>{`Median Earnings of Research-Funded ${selectedType.replace("Student", "Students").replace("Postdoc", "Postdocs").replace("Undergraduate", "Undergraduates")} in ${selectedIndustry} (Top 10 Companies)`}</Heading3>
                </TitleDiv>
                <div id="BarChart"></div>
            </div>
            <div>
                <ReportText><TextSpan bold>Employee type</TextSpan></ReportText>
                {(employeeTypes.length > 0) &&
                    employeeTypes.filter(x => { return x.selected == true }).map(
                        (item, idx) => (<ReportButton key={idx} active={selectedType == item.type} onClick={() => handleType(item.type)}>{item.type}</ReportButton>)
                    )
                }
            </div>
            <div>
                <ReportText><TextSpan bold>Industry</TextSpan></ReportText>
                {(industries.length > 0) &&
                    industries.filter(x => { return x.selected == true }).map(
                        (item, idx) => (<ReportButton key={idx} active={selectedIndustry == item.type} onClick={() => handleIndustry(item.type)}>{item.type}</ReportButton>)
                    )
                }
            </div>
            <p>This chart displays data for one employee type and one industry at a time, which are selected using the buttons below. Add or remove buttons using the Employee Types filter on the right.</p>
            <ReportText bold>* Employers with fewer than 5 employees are not displayed for privacy.</ReportText>
        </Container>
    );
}

const Container = styled.div`
    display: grid;
    gap: 2em;
`;

export default TopCompanies;